import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { MyEquipmentButton } from 'components/pcc-components';
import { useTranslations } from 'next-intl';

export const DeleteEquipmentButton = ({
  disableDeleteButton = false,
}: {
  disableDeleteButton?: boolean;
}) => {
  const t = useTranslations();

  const { deleteEquipmentDrawer } = useMyEquipmentDrawer();
  const isDeleteEquipmentDrawerChild = true;
  const handleOpen = () =>
    deleteEquipmentDrawer.openDrawer(null, isDeleteEquipmentDrawerChild);
  return (
    <MyEquipmentButton
      type="button"
      onClick={handleOpen}
      className="mt-3"
      variant="danger"
      disabled={disableDeleteButton}
    >
      {t('DELETE_EQUIPMENT')}
    </MyEquipmentButton>
  );
};
